import React from 'react';
import { Element } from './SubmittedButton.styles';
import { Hr } from '@/components/separator/HorizontalRule/HorizontalRule.styles';
import { Button } from '@/components/button';

export interface SubmittedButtonProps {
  setSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
  resetFeedback: () => void;
}

const SubmittedButton = ({ setSubmitted, resetFeedback }: SubmittedButtonProps) => {
  return (
    <Element>
      <Hr spacing="base" />
      <Button
        type="button"
        appearance="link"
        size="base"
        onClick={() => {
          setSubmitted(() => false);
          resetFeedback();
        }}
      >
        Clique aqui para enviar outra solicitação
      </Button>
    </Element>
  );
};

export default SubmittedButton;
